import { Injectable, signal, computed } from '@angular/core';
import { LangCode, TRANSLATIONS } from './translations';

export type { LangCode };

/** Marketing-site i18n (isolated from the in-app LanguageService). */
@Injectable({ providedIn: 'root' })
export class SiteLanguageService {
  readonly lang = signal<LangCode>(this.readStored());

  readonly dict = computed(() => TRANSLATIONS[this.lang()]);

  constructor() {
    this.applyDocumentLang(this.lang());
  }

  setLang(code: LangCode): void {
    if (this.lang() === code) return;
    this.lang.set(code);
    try {
      localStorage.setItem('vevarok-lang', code);
    } catch {
      /* ignore */
    }
    this.applyDocumentLang(code);
  }

  private applyDocumentLang(code: LangCode): void {
    if (typeof document === 'undefined') return;
    document.documentElement.lang = code === 'hi' ? 'hi' : code === 'gu' ? 'gu' : 'en';
  }

  t(key: string): string {
    // Read lang() so every template call to t() creates a reactive dependency.
    this.lang();
    const d = this.dict();
    return d[key] ?? TRANSLATIONS.en[key] ?? key;
  }

  languageId(): number {
    switch (this.lang()) {
      case 'hi':
        return 2;
      case 'gu':
        return 3;
      default:
        return 1;
    }
  }

  private readStored(): LangCode {
    try {
      const stored = localStorage.getItem('vevarok-lang') as LangCode | null;
      if (stored === 'en' || stored === 'hi' || stored === 'gu') return stored;
    } catch {
      /* ignore */
    }
    return 'en';
  }
}
